// pages/QrMenuDemo.jsx
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "./QrMenuDemo.css"; // Instagram-style CSS

export default function QrMenuDemo() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const projects = [
    {
      title: "Pascali Ռեստորան",
      url: "https://www.pascali.am",
      description: "Ռեստորանի դեմո կայք Երևանում։",
    },
    {
      title: "Dos Պորտֆոլիո",
      url: "https://dosevn.am",
      description: "Նարգիլե բարի դեմո կայք Երևանում։",
    },
    {
      title: "Բիլիարդ Բարի Դեմո",
      url: "https://www.blackball.am",
      description: "Բիլիարդ բարի դեմո մենյու Երևանում։",
    },
    {
      title: "Արտաշատ Էկոայգի",
      url: "https://www.artshatecogarden.com/",
      description: "Ռեստորան",
    },
    {
      title: "Tjvjik Ռեստորան",
      url: "https://tjvjik.am/",
      description: "Ռեստորան",
    },
    {
      title: "Bombon",
      url: "https://bombon.am/",
      description: "Սրճարան / Ռեստորան",
    },
    {
      title: "Lastiver Resort",
      url: "https://lastiverresort.am/",
      description: "Հանգստյան գոտի և Ռեստորան",
    },
  ];

  return (
    <div className={`qrmenu-page insta-bg ${darkMode ? "dark" : "light"}`}>
      {/* SEO Meta */}
      <Helmet>
        <title>QR Մենյու Live Demo | Փորձարկեք համակարգը առցանց</title>
        <meta
          name="description"
          content="Դիտեք մեր QR մենյուի համակարգի live demo-ն։ Սկանավորեք, ուսումնասիրեք և տեսեք, թե ինչպես է այն աշխատում ռեստորանների, սրճարանների և հյուրանոցների համար։"
        />
      </Helmet>

      {/* Theme Toggle */}
      <div className="theme-toggle" data-aos="fade-down">
        <button onClick={() => setDarkMode(!darkMode)} className="toggle-btn">
          {darkMode ? "☀️ Լուսավոր" : "🌙 Մութ"}
        </button>
      </div>

      {/* Iframe Preview for Demo */}
      <section className="demo-preview" data-aos="fade-up">
        <h2 className="insta-text">📱 Տեսեք QR մենյուն գործողության մեջ</h2>
        <p className="demo-description">
          Ստորև կարող եք տեսնել իրական մենյուների կենդանի նախադիտումներ սարքերի շրջանակներում։
          Սկանավորեք, ուսումնասիրեք և զգացեք, թե ինչպես է մեր QR մենյուն աշխատում իրական կյանքում։
        </p>

        <div className="device-mockups">
          {projects.map((project, index) => (
            <div
              key={index}
              className="device-mockup"
              data-aos="zoom-in"
              data-aos-delay={index * 200}
            >
              <span className="watch-label">👁 Դիտել {project.title}</span>
              <div className="device-frame">
                <div className="device-screen">
                  <iframe
                    src={project.url}
                    title={project.title}
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* QR Codes for Each Project */}
      <section className="projects-qr" data-aos="fade-up">
        <h2 className="insta-text">Նախագծերի QR կոդերը</h2>
        <div className="qr-grid">
          {projects.map((project, index) => (
            <div
              key={index}
              className="qr-card card"
              data-aos="flip-left"
              data-aos-delay={index * 150}
            >
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
                  project.url
                )}`}
                alt={`QR for ${project.title}`}
                className="demo-qr"
                loading="lazy"
              />
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Բացել նախագիծը
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="contact-now" data-aos="fade-up">
        <h2 className="insta-text">Ցանկանու՞մ եք սա ձեր բիզնեսի համար։</h2>
        <div className="hero-cta-buttons">
          <a href="/qr-menu" className="cta-button">
            Վերադառնալ հնարավորություններին
          </a>
          <a href="/contact" className="cta-button">
            Կապ մեզ հետ
          </a>
        </div>
      </section>
    </div>
  );
}
